import gql from 'graphql-tag';

export default gql`
    mutation DeleteJobImage($input: DeleteJobImageRequest) {
        deleteJobImage(input: $input) {
            errors
        }
    }
`;
